import { render, staticRenderFns } from "./BillingChargeAmount.vue?vue&type=template&id=49935800"
import script from "./BillingChargeAmount.vue?vue&type=script&lang=js"
export * from "./BillingChargeAmount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports